import {initFlowbite} from 'flowbite';

window.onload = () => {
    initFlowbite();
};
